import React, { memo } from 'react';

import { areEqualShallow } from 'Utils/equalityChecks';
import NotesButton from '../../../Assets/notes-button.svg';

// Custom css
import classes from './notesButton.module.css';

interface Props {
  className?: string;
  id?: string;
  onClick?: (e: any) => void;
  onKeyUp?: (e: any) => void;
}
const NotesButtonSvg = ({ className = '', id, onClick, onKeyUp }: Props) => (
  <NotesButton
    id={id}
    className={`${classes.notesButtonBase} ${className || ''}`}
    onClick={onClick}
    onKeyUp={onKeyUp}
  />
);

NotesButtonSvg.defaultProps = {
  className: undefined,
  id: undefined,
  onClick: undefined,
  onKeyUp: undefined,
};

const NotesButtonSvgMemo = memo(NotesButtonSvg, areEqualShallow);
export { NotesButtonSvgMemo as NotesButtonSvg };
